import { Logger } from '@capsicum/common';
import { useNCWBalance } from '@capsicum/socios-core';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { v2MigrationTxHashAtom } from '../data-access';

import { useMigrationCounterMutation } from './useMigrationCounterMutation';

type UseV2MigrationTxHashSyncProps = {
	enabled?: boolean;
};

export const useV2MigrationTxHashSync = ({ enabled = true }: UseV2MigrationTxHashSyncProps) => {
	const { refetchNcWalletBalance } = useNCWBalance();
	const [txHash, setTxHashAtom] = useAtom(v2MigrationTxHashAtom);
	const { isPending: isCounterMutationLoading, mutateAsync: mutateMigrationCounter } = useMigrationCounterMutation();

	useEffect(() => {
		if (!enabled || !txHash) return;

		const fn = async () => {
			try {
				await mutateMigrationCounter({ hashes: [txHash] });
				setTxHashAtom(null);
				refetchNcWalletBalance();
			} catch (e) {
				Logger.error('V2Migration: ERROR: Failed to record migration tx hash during app start-up', {
					e,
					txHash
				});
			}
		};

		fn();
	}, [txHash, enabled, refetchNcWalletBalance, mutateMigrationCounter]);

	return {
		isLoading: isCounterMutationLoading
	};
};
